import React from "react";
import { Box, Typography, TextField, InputAdornment, MenuItem, Select } from "@mui/material";
import { MobileTimePicker } from '@mui/x-date-pickers';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./TimePickerStyles";
import dayjs from "dayjs"; // You can still use dayjs to format the time

export const TimePickerComponent = ({
    value,
    onChange,
    valuePeriod,
    onChangePeriod,
    Label,
    errorMessage, error, placeholder
}: any) => (
    <Box sx={styles.timePickerMAIN}>
        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", flexDirection: "row", alignItems: "center" }}>
            <Typography variant="h6" fontSize={16} fontWeight={500} mt={1} gutterBottom>
                {Label}
            </Typography>
            {<Typography fontSize={10} sx={{ color: error ? "red" : "white" }} >{errorMessage ? errorMessage : " . "}</Typography>}
        </Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={styles.timePickerBox}>
                <MobileTimePicker
                    value={value ? dayjs(value, 'HH:mm') : null} // Use 'HH:mm' format to parse time
                    onChange={(newValue) => onChange(newValue ? newValue.format('HH:mm') : null)} // Only update the time
                    ampm={false} // 24-hour format
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            variant="outlined"
                            sx={styles.timePickerInput}
                            placeholder={"" || placeholder}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {value && (
                                            <Box sx={styles.closeButtonStyle} onClick={() => onChange(null)}>
                                                <CloseIcon sx={styles.closeIconStyle} />
                                            </Box>
                                        )}
                                        <AccessTimeIcon sx={styles.inputColorStyle} />
                                    </InputAdornment>
                                ),
                                style: styles.inputColorStyle,
                            }}
                        />
                    )}
                />
                <Select
                    size="small"
                    value={valuePeriod}
                    onChange={(event) => onChangePeriod(event.target.value)}
                    disabled={!value}
                    sx={{ ml: 1, color: '#A1A1A1' }}
                >
                    <MenuItem value="AM">AM</MenuItem>
                    <MenuItem value="PM">PM</MenuItem>
                </Select>
            </Box>
        </LocalizationProvider>
    </Box>
);
